/* mm-megamenu.js — Megamenú de dos paneles (raíl de secciones + subcategorías).
   Mantiene ACTIVA la sección elegida hasta que se elige otra, marcando la fila
   con la clase .mm-active. Así el puntero puede viajar desde el raíl hasta el
   panel derecho en diagonal SIN que la sección desaparezca (evita el clásico
   "diagonal problem" del hover puro en CSS).
   Reversible: borra este archivo y su <script> en snippets/stylesheets.liquid. */
(function () {
  function rowsWithSubmenu(list) {
    var cols = list.querySelectorAll(':scope > .mega-menu__column');
    var rows = [];
    for (var i = 0; i < cols.length; i++) {
      if (cols[i].querySelector(':scope > div > ul')) rows.push(cols[i]);
    }
    return rows;
  }

  function initList(list) {
    if (list.dataset.mmTwopane) return;
    if (!list.querySelector('.mega-menu__link--parent')) return; // sólo menús con secciones
    var rows = rowsWithSubmenu(list);
    if (!rows.length) return;

    function activate(row) {
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('mm-active', rows[i] === row);
      }
    }

    var timer = null;
    rows.forEach(function (row) {
      // pointerenter: intención de abrir esa sección (pequeño colchón anti-parpadeo)
      row.addEventListener('pointerenter', function () {
        if (timer) { clearTimeout(timer); timer = null; }
        activate(row);
      });
      // teclado / accesibilidad
      row.addEventListener('focusin', function () { activate(row); });
    });

    activate(rows[0]);              // por defecto, primera sección con contenido
    list.dataset.mmTwopane = '1';   // desactiva el fallback CSS
  }

  function run() {
    var lists = document.querySelectorAll('.mega-menu__list');
    for (var i = 0; i < lists.length; i++) initList(lists[i]);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  setTimeout(run, 600);
  setTimeout(run, 1500);

  // La cabecera puede re-renderizarse (Section Rendering API): inicializa al vuelo.
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    var list = t && t.closest ? t.closest('.mega-menu__list') : null;
    if (list) initList(list);
  }, true);
})();

/* MM 25-10-2026 · Menú de escritorio con intención de ratón.
   Antes: al bajar de «Pájaros» al desplegable, si el cursor cruzaba otra categoría o se detenía en el hueco de 7 px
   entre el enlace y el panel, el menú cambiaba o se cerraba.
   Ahora, con un desplegable abierto:
   - cambiar a otra categoría exige que el cursor se quede quieto sobre ella 180 ms (al pasar por encima no cambia);
   - el menú solo se cierra si el cursor está fuera de la barra y del panel durante 400 ms (el hueco cuenta como dentro).
   Escucha en window (captura) para ir antes que los eventos declarativos del tema Horizon. Solo ratón. */
(function () {
  if (window.mmMenuAim) return; window.mmMenuAim = 1;
  var SWITCH_MS = 220, CLOSE_MS = 400, PAD = 12;
  var ours = new WeakSet(), tSwitch = null, tClose = null, pending = null;
  var px = 0, py = 0, lastMove = 0;
  function li(t) { return t && t.closest ? t.closest('header-menu .menu-list__list-item') : null; }
  function openLi() {
    var a = document.querySelector('header-menu .menu-list__list-item > [ref="menuitem"][aria-expanded="true"]');
    return a ? a.parentElement : null;
  }
  function fire(el, type) { var e = new PointerEvent(type, { bubbles: false, pointerType: 'mouse' }); ours.add(e); el.dispatchEvent(e); }
  function mouse(e) { return !ours.has(e) && e.pointerType !== 'touch' && e.pointerType !== 'pen'; }
  function inZone(cur) {
    var nav = cur.closest('nav') || cur.closest('header-menu'), sub = cur.querySelector('.menu-list__submenu-inner');
    var a = nav.getBoundingClientRect(), b = sub ? sub.getBoundingClientRect() : a;
    var top = Math.min(a.top, b.top) - PAD, bottom = Math.max(a.bottom, b.bottom) + PAD;
    var left = Math.min(a.left, b.left), right = Math.max(a.right, b.right);
    return px >= left && px <= right && py >= top && py <= bottom;
  }
  function stopAll() { clearTimeout(tSwitch); clearTimeout(tClose); tSwitch = tClose = null; pending = null; }
  function armSwitch() {
    clearTimeout(tSwitch);
    tSwitch = setTimeout(function () {
      tSwitch = null;
      var item = pending; if (!item || !openLi()) return;
      if (!item.matches(':hover')) { pending = null; return; }
      if (performance.now() - lastMove < SWITCH_MS - 10) { armSwitch(); return; }
      pending = null; clearTimeout(tClose); tClose = null; fire(item, 'pointerenter');
    }, SWITCH_MS);
  }
  function armClose() {
    clearTimeout(tClose);
    tClose = setTimeout(function () {
      tClose = null;
      var cur = openLi(); if (!cur || cur.matches(':hover')) return;
      if (pending && pending.matches(':hover')) return;          /* lo decide el cambio de categoría */
      if (inZone(cur)) { armClose(); return; }                    /* sigue sobre la barra o el hueco */
      pending = null; fire(cur, 'pointerleave');
    }, CLOSE_MS);
  }
  window.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    if (Math.abs(e.clientX - px) + Math.abs(e.clientY - py) > 2) lastMove = performance.now();
    px = e.clientX; py = e.clientY;
  }, { capture: true, passive: true });
  window.addEventListener('pointerenter', function (e) {
    if (!mouse(e)) return;
    var item = li(e.target); if (!item || e.target !== item) return;
    var cur = openLi();
    if (!cur) { stopAll(); return; }                    /* nada abierto: comportamiento normal del tema */
    if (cur === item) { stopAll(); return; }            /* vuelve a la categoría abierta o entra en su panel */
    e.stopImmediatePropagation();
    pending = item; armSwitch();
  }, true);
  window.addEventListener('pointerleave', function (e) {
    if (!mouse(e)) return;
    var item = li(e.target); if (!item || e.target !== item) return;
    var cur = openLi(); if (!cur) return;
    e.stopImmediatePropagation();                       /* el tema cerraría el panel abierto al salir de cualquier categoría */
    if (item === pending) { clearTimeout(tSwitch); tSwitch = null; pending = null; }
    armClose();
  }, true);
})();
